<template>
  <camelot-toast :type="type" :message="message" :auto-close.prop="autoClose" @closeToast="destroy" />
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  name: 'toast',
  props: {
    autoClose: {
      default: true,
      type: Boolean,
    },
    message: {
      default: 'There was an error. Please try again later.',
      type: String,
    },
    type: {
      default: 'error',
      type: String,
    },
  },
})
export default class Toast extends Vue {
  public autoClose?: boolean;
  public message!: string;
  public type!: string;
  public destroy() {
    this.$destroy();
    (this.$el.parentNode as HTMLElement).removeChild(this.$el);
  }
}
</script>
